import { ID as BLOG_POST_ID } from './BlogPost';
import BlogPost from './BlogPost/legacy';
import { ID as BREADCRUMBS_ID } from './Breadcrumbs';
import Breadcrumbs from './Breadcrumbs/legacy';
import { ID as BUTTON_ID } from './Button';
import Button from './Button/legacy';
import { ID as CONTENT_BOX_ID } from './ContentBox';
import ContentBox from './ContentBox/legacy';
import { ID as DIRECTIONS_TEXT_ID } from './DirectionsText';
import DirectionsText from './DirectionsText/legacy';
import { ID as FACILITY_INFORMATION_ID } from './FacilityInformation';
import FacilityInformation from './FacilityInformation/legacy';
import { ID as HEADER_LOGO_ID } from './HeaderLogo';
import HeaderLogo from './HeaderLogo/legacy';
import { ID as HEADER_TEXT_ID } from './HeaderText';
import HeaderText from './HeaderText/legacy';
import { ID as HOURS_ID } from './Hours';
import Hours from './Hours/legacy';
import { ID as PLACEHOLDER_ID } from './Placeholder';
import Placeholder from './Placeholder/legacy';
import { ID as SOCIAL_MEDIA_ICONS_ID } from './SocialMediaIcons';
import SocialMediaIcons from './SocialMediaIcons/legacy';
import { ID as STOCK_ICONS_ID } from './StockIcons';
import StockIcons from './StockIcons/legacy';

export default {
  [BLOG_POST_ID]: BlogPost,
  [BREADCRUMBS_ID]: Breadcrumbs,
  [BUTTON_ID]: Button,
  [CONTENT_BOX_ID]: ContentBox,
  [DIRECTIONS_TEXT_ID]: DirectionsText,
  [FACILITY_INFORMATION_ID]: FacilityInformation,
  [HEADER_LOGO_ID]: HeaderLogo,
  [HEADER_TEXT_ID]: HeaderText,
  [HOURS_ID]: Hours,
  [PLACEHOLDER_ID]: Placeholder,
  [SOCIAL_MEDIA_ICONS_ID]: SocialMediaIcons,
  [STOCK_ICONS_ID]: StockIcons,
};
